import { render } from "./SearchForm.vue?vue&type=template&id=a63b6e98&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=a63b6e98&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a63b6e98"

export default script